
    import { Component, Vue, Prop } from 'vue-property-decorator';
    import moment from 'moment-timezone';

    import FormList from "./components/FormList.vue"
    
    import { stepInfoType } from "@/types/Application";

    import PageBase from "../PageBase.vue";    
    import GetHelpForPdf from "./helpPages/GetHelpForPDF.vue"
    import GetHelpScanning from "./helpPages/GetHelpScanning.vue"    

    import { namespace } from "vuex-class";   
    import "@/store/modules/application";
    const applicationState = namespace("Application");

    import "@/store/modules/common";
    const commonState = namespace("Common");


    @Component({
        components:{
            PageBase,
            GetHelpForPdf,
            GetHelpScanning,
            FormList
        }
    })
    
    export default class ReviewAndSubmit extends Vue {
        
        @Prop({required: true})
        step!: stepInfoType;

        @commonState.State
        public userLocation!: string;

        @applicationState.State
        public id!: string;

        @applicationState.State
        public steps!: stepInfoType[];

        @applicationState.State
        public applicationLocation!: string;

        @applicationState.State
        public deceasedDateOfDeath!: string;

        @applicationState.State
        public currentStep!: number;

        // @applicationState.State
        // public requiredDocuments!: string[];

        @applicationState.Action
        public UpdateGotoPrevStepPage!: () => void

        @applicationState.Action
        public UpdateGotoNextStepPage!: () => void

        @applicationState.Action
        public UpdateCurrentStep!: (newCurrentStep) => void

        @applicationState.Action
        public UpdateCurrentStepPage!: (newCurrentStepPage) => void

        @applicationState.Action
        public UpdatePageProgress!: (newPageProgress) => void        

        @applicationState.Action
        public UpdateLastPrinted!: (newLastPrinted) => void

        @applicationState.State
        public documentTypesJson!: any;

        @applicationState.State
        public supportingDocuments!: any;
        @applicationState.Action
        public UpdateSupportingDocuments!: (newSupportingDocuments) => void

        @applicationState.State
        public generatedForms!: string[];


        error = "";
        showGetHelpForPDF = false;
        showGetHelpScanning = false;
        applicantLocation = {name:'', address:'', cityStatePostcode:'', email:''}        
        submissionInProgress = false;
        
        supportingFile = null;
        selectedDocumentTypeState = true;
        selectedSupportingDocumentState = true;
        fileType = "";
        fileTypes = [];
        requiredDocuments: string[] = [];
        supportingDocumentFields = [
            { key: 'fileName', label: 'File Name',tdClass:'align-middle'},
            { key: 'fileType', label: 'File Type',tdClass:'align-middle'},
            { key: 'edit', thClass: 'd-none',tdClass:'align-middle'},
            { key: 'preview', thClass: 'd-none'}
        ];
       
        showTypeOfDocuments = false;

        submitEnable = true;
        formsList = [];

        mounted(){

            this.submitEnable =  true;
            const progress = 50;

            //console.log(this.currentStep)
            //console.log(this.steps[this.currentStep])
            this.UpdatePageProgress({ currentStep: this.currentStep, currentPage:this.steps[this.currentStep].currentPage, progress:progress });
       
            let location = this.applicationLocation
            if(!this.applicationLocation) location = this.userLocation;
       

            if(location == 'Victoria'){
                this.applicantLocation = {name:'Victoria Law Courts', address:'850 Burdett Avenue', cityStatePostcode:'Victoria, B.C.  V8W 9J2', email:'Victoria.CourtScheduling@gov.bc.ca'}
            } else if(location == 'Surrey'){
                this.applicantLocation = {name:'Surrey Provincial Court', address:'14340 - 57 Avenue', cityStatePostcode:'Surrey, B.C.  V3X 1B2', email:'CSBSurreyProvincialCourt.FamilyRegistry@gov.bc.ca'}
            }
            //TODO: use get api for document-types           
            this.fileTypes = this.documentTypesJson;
            this.requiredDocuments = Vue.filter('extractRequiredDocuments')(this.getRepGrantResultData())

            const dropArea = document.getElementById('drop-area');
            dropArea.addEventListener('drop', this.handleFileDrop, false);
            dropArea.addEventListener('dragenter', this.dragPreventDefaults, false);
            dropArea.addEventListener('dragleave', this.dragPreventDefaults, false);
            dropArea.addEventListener('dragover', this.dragPreventDefaults, false);            
        }

        public dragPreventDefaults (e) {
            e.preventDefault()
            e.stopPropagation()
        }

        public handleFileDrop(e) {
            e.preventDefault()
            e.stopPropagation()
            const dt = e.dataTransfer
            const files = dt.files
            console.log(files)
            if (files && files[0]) 
            {
                this.supportingFile = files[0];
                this.showTypeOfDocuments= true;
            }
        } 

        public uploadClicked(){
            console.log('click')
            const el = document.getElementById("inputfile");
            if(el) el.click();
        }

        public handleSelectedFile(event){
            console.log(event)
            event.preventDefault();
            event.stopPropagation();
            console.log(event.target.files[0])
            
            if (event.target.files && event.target.files[0]) 
            {
                this.supportingFile = event.target.files[0];
                this.showTypeOfDocuments= true;
            }
        }
        
        public onPrev() {
            this.UpdateGotoPrevStepPage()
        }

        public onNext() {
            this.UpdateGotoNextStepPage()
        }

        public onDownload() {
            console.log('downloading')
            // if(this.checkErrorOnPages()){
            //     const currentDate = moment().format();
            //     this.UpdateLastPrinted(currentDate);
            //     this.loadPdf();
            // }
        }

        public checkErrorOnPages(){
            
            const optionalLabels = ["Next Steps", "Review and Print", "Review and Save", "Review and Submit"]

            for(const step of this.steps){
                if(step.active){
                    for(const page of step.pages){
                        if(page.active && page.progress!=100 && optionalLabels.indexOf(page.label) == -1){
                            this.UpdateCurrentStep(step.id);
                            this.UpdateCurrentStepPage({currentStep: step.id, currentPage: page.key });
                            // const nextChildGroup = document.getElementById(this.getStepGroupId(step.id));
                           
                            // if(nextChildGroup){
                            //     if(Number(step.id)==8){
                            //         nextChildGroup.style.display = "none";
                            //         Vue.nextTick(()=>nextChildGroup.style.display = "block")
                            //     }else{
                            //         nextChildGroup.style.display = "block";
                            //     }
                            // }
                        
                            return false;
                        }
                    }
                }
                
            }
            return true;
        }

        public getStepId(stepIndex) {
            return "step-" + stepIndex;
        }

        public getStepGroupId(stepIndex) {
            return this.getStepId(stepIndex) + "-group";
        }

        public getStepPageId(stepIndex, pageIndex) {
            return this.getStepId(stepIndex) + "-page-" + pageIndex;
        }

        

        public getRepGrantResultData() {      
            var result = this.steps[0].result; 
            for(var i=1;i<9; i++){
                const stepResults = this.steps[i].result
                for(const stepResult in stepResults){                    
                    result[stepResult]=stepResults[stepResult].data;  
                }
            } 
            
            var deceasedDateOfDeath = {deceasedDateOfDeath: this.deceasedDateOfDeath}
            Object.assign(result, result, deceasedDateOfDeath);           
           
            if(this.applicationLocation)
                Object.assign(result, result,{applicationLocation: this.applicationLocation}); 
            else
                Object.assign(result, result,{applicationLocation: this.userLocation});
            return result;
        }

        public setFormList(formsList){
            this.formsList = formsList
        }

        public onSubmit() {
            for(const form of this.formsList)
                if(!this.generatedForms.includes(form.name)){
                    //console.log(form)
                    const el = document.getElementById('formslist')	
                    //console.log(el)		
			        if(el) el.scrollIntoView();
                    
                    return
                }
            console.log("submit")

            // if(this.checkErrorOnPages()){
            //     this.eFile();
            // }            
        }

         public eFile() {
            
            const bodyFormData = new FormData();
            const docType = []
            for(const index in this.supportingDocuments){
                const supportingDoc = this.supportingDocuments[index]
                bodyFormData.append('files',supportingDoc['file']); 
                          
                docType.push({type: supportingDoc['documentType'], files: [Number(index)], rotations:[supportingDoc['imageRotation']]})
               // bodyFormData.append('documents', );
               // console.log(supportingDoc['imageRotation'])
            }
            console.log(docType);
            const docTypeJson = JSON.stringify(docType);
            const docTypeBlob = new Blob([docTypeJson], {type: 'application/json'});
            bodyFormData.append('documents', docTypeJson);
            

            console.log(bodyFormData.get('documents'))

            const url = "/efiling/"+this.id+"/submit/" 
            const header = {
                responseType: "json",
                headers: {
                    "Content-Type": "multipart/form-data",
                    Accept: "application/json"                  
                }
            }
            
            this.submissionInProgress = true;
            
            this.$http.post(url, bodyFormData, header)
            .then(res => {
                console.log(res)
                if(res.data.message=="success")
                {
                    this.generateUrl(res.data.redirectUrl)                   
                }
            }, err => {
                console.error(err);
                this.error = err;
                this.submissionInProgress = false;
            });           
        }
        
        public generateUrl(eFilingUrl) {            
            // redirect user to the generated url
            location.replace(eFilingUrl);        
        }

        public removeDocument(index) {
            this.supportingDocuments.splice(index, 1);
        }
        
        public addDocument() {
            this.selectedSupportingDocumentState = this.supportingFile? true:false;
            this.selectedDocumentTypeState = this.fileType.length>0? true: false;

            if (this.supportingFile && this.fileType.length>0) {

                this.showTypeOfDocuments = false;

                const supportingdocuments = this.supportingDocuments 
              
                const newFile = {
                    "fileName": this.supportingFile.name,
                    "file": this.supportingFile,
                    "documentType": this.fileType,
                    "image": URL.createObjectURL(this.supportingFile),
                    "imageRotation": 0
                }
                supportingdocuments.push(newFile);
                this.UpdateSupportingDocuments(supportingdocuments);
                this.supportingFile = null;
                this.fileType = "";
                
            }
        }
    }
